export function getCurrentYear() {
  return new Date().getFullYear();
}

export function getYearStartDate(year) {
  const startDate = new Date(year, 0, 1);
  return startDate.toISOString().split('T')[0];
}

export function getYearEndDate(year) {
  const endDate = new Date(year, 11, 31);
  return endDate.toISOString().split('T')[0];
}
